import Vue from 'vue'

import {
  mapGetters
} from 'vuex'

import NewsItemsService from 'js/services/api/passenger/news-items.js'

import template from './index.pug'

export default Vue.extend({
  name: 'news-page',
  template: template(),
  data() {
    return {
      news: [],
      deltaTabIndex: 100,
    }
  },

  computed: {
    slug() {
      return this.$route.params.slug
    }
  },

  watch: {
    slug() {
      this.getNews()
    }
  },

  created() {
    this.getNews()
  },

  methods: {
    getNews() {
      const params = {
        order_by: 'date',
        order_dir: 'desc'
      }

      if (this.slug) {
        // Se trae la noticia correspondiente al slug
        params.slug = this.slug
      }

      if (this.currentMunicipality && this.currentMunicipality.id) {
        // Se trae las noticias del municipio
        params.municipality_ids = this.currentMunicipality.id
      } else {
        // Se trae las noticias del ámbito
        params.include_in_general = true
      }

      NewsItemsService.index(params).then(response => {
        this.news = response.data
      })
    },
    dateFormat(date) {
      return moment(date).format('D MMMM, YYYY')
    },
    copyURL(slug) {
      const copy = require('clipboard-copy')
      if (this.slug) {
        copy(location.href)
      } else {
        copy(`${location.href}/${slug}`)
      }
    },

    applyContrasteCss() {
      // console.log(`applying high contrast for component ${this.$options.name} (${this.contraste})`)

      if (this.contraste) {
        $(".ns-layout ,.ns-layout__header, .text-black , .text-gray2 , .sidepanel-map__card--item__stop--route , .sidepanel-map__card--item__stop ,.flex-middle,.ns-layout__footer__footer").css("cssText", " color: #ffffff !important")
        $(".ns-layout ,.ns-layout__header, .text-black , .text-gray2 , .sidepanel-map__card--item__stop--route , .sidepanel-map__card--item__stop").css("background-color", "#1e1e1e")
        $(".text-primary , .text-gray2-hover , .button-phone , .text-gray3 , .ns-layout__sidebar__map__menu").css("cssText", " color: #ffffff !important")
        $(".text-primary , .text-gray2-hover , .button-phone , .text-gray3 ").css("background-color", "#1e1e1e")
        $("a ,.sidepanel-map__container, .recharge-home__recharges , .recharge-home__cities , .ns-layout__footer__items , .pb-d6 , .sidepanel-map__card--item__point-name").css("color", "#fff")
        $(".sidepanel-map__container, .recharge-home__recharges , .recharge-home__cities , .ns-layout__footer__items ,.pb-d6, .sidepanel-map__card--item__point-name,.flex-middle ,.sidepanel-map__header").css("cssText", "background-color: #1e1e1e !important")
        $(".sidepanel-map--planner__form , .uppercase-vz ,.hidden-xs ,.panel,.ns-field__label,.uppercase ,#fares-side-menu,.flex-column").css("color", "#fff")
        $(".sidepanel-map--planner__form , .uppercase-vz ,.hidden-xs ,.panel,.ns-field__label,.uppercase ,#fares-side-menu,.flex-column").css("background-color", "#1e1e1e")
        $("label,.ns-tabs__item,.primay-dark,.text-small, .ns-icon-angle-right ,.h1-main-title,.text-main-title ").css("color", "#fff")
        $("label,.ns-tabs__item,.primay-dark,.text-small, .ns-icon-angle-right ,.h1-main-title,.text-main-title,.colorFondo ").css("background-color", "#1e1e1e")
        $(".ns-layout__header--city , .ns-button,.text-info , .ns-icon-youtube").css("color", "#1e1e1e");
        $(".ns-layout__header--city , .ns-button,.text-info , .ns-icon-youtube").css("background-color", "#fff")
        $(" .pb-d6 ").css("color", "#fff")
        $("#iconorestablecer").css("color", "#1e1e1e");
        $("#iconorestablecer").css("background-color", "#fff")
        $("#textorestablecer").css("color", "#1e1e1e");
        $("#textorestablecer").css("background-color", "#fff")
        $(".text-gray2,.text-primary-hover ,.ns-layout__footer, .ns-layout__footer__footer,.hidden-cl ").css("cssText", " color: #ffffff !important")
        $(".panel-schedules ,.px-d2 , .ns-session__nav--login ,.ns-layout__footer__footer").css("cssText", "background-color: #1e1e1e !important")
        $(".ns-tabs ").css("background-color", "#1e1e1e")
        $("#linkhome ").css("cssText", "color: #1e1e1e !important")

        $(".tablacss ").css("cssText", "color: #1e1e1e !important")
        $(".tablacss ").css("background-color", "#fff")
        $(".ns-icon-angle-left,.sidepanel-map__card--item__stop ").css("color", "#fff")
        $(".ns-icon-angle-left ").css("background-color", "#1e1e1e")
        $("#linkhome ").css("cssText", "color: #1e1e1e !important")
        $(".ns-layout__sidebar__map__menu").css("background-color", "#ffffff")
        $(".textomenu ").css("cssText", "color: #1e1e1e !important")
        $("#linkhome ").css("cssText", "color: #1e1e1e !important")
        $(".ns-layout__sidebar__map__menu").css("background-color", "#ffffff")
        $(".textomenu ").css("cssText", "color: #1e1e1e !important")

        $(".submenuusuario").css("background-color", "#ffffff")
        $(".submenuusuario").css("cssText", "color: #1e1e1e !important")

        $(".button-phone").css("border", "2px solid #ffffff")
        $(".option-menu").css("border", "none")
        $(".active").css("background-color", "transparent").css("border", "2px solid #1e1e1e");
      } else {

        $(".ns-layout ,.ns-layout__header, .text-black , .text-gray2 , .sidepanel-map__card--item__stop--route , .sidepanel-map__card--item__stop").css("color", "")
        $(".ns-layout ,.ns-layout__header, .text-black , .text-gray2 , .sidepanel-map__card--item__stop--route , .sidepanel-map__card--item__stop").css("background-color", "")
        $(".text-primary , .text-gray2-hover , .button-phone , .text-gray3 , .ns-layout__sidebar__map__menu").css("color", "")
        $(".text-primary , .text-gray2-hover , .button-phone , .text-gray3 , .ns-layout__sidebar__map__menu").css("background-color", "")
        $("a ,.sidepanel-map__container, .recharge-home__recharges , .recharge-home__cities , .ns-layout__footer__items , .pb-d6 , .sidepanel-map__card--item__point-name").css("color", "")
        $(".sidepanel-map__container, .recharge-home__recharges , .recharge-home__cities , .ns-layout__footer__items ,.pb-d6, .sidepanel-map__card--item__point-name,.flex-middle ,.sidepanel-map__header").css("background-color", "")
        $(".sidepanel-map--planner__form , .uppercase-vz ,.hidden-xs ,.panel,.ns-field__label,.uppercase ,#fares-side-menu,.flex-column").css("color", "")
        $(".sidepanel-map--planner__form , .uppercase-vz ,.hidden-xs ,.panel,.ns-field__label,.uppercase ,#fares-side-menu,.flex-column").css("background-color", "")
        $("label,.ns-tabs__item,.primay-dark,.text-small, .ns-icon-angle-right ,.h1-main-title,.text-main-title ").css("color", "")
        $("label,.ns-tabs__item,.primay-dark,.text-small, .ns-icon-angle-right ,.h1-main-title,.text-main-title,.ns-session__nav--login ").css("background-color", "")
        $(".ns-layout__header--city , .ns-button,.text-info , .ns-icon-youtube,.ns-tabs, .button-tabs,.text-primary-hover,.ns-layout__footer__footer,.hidden-cl").css("color", "");
        $(".ns-layout__header--city , .ns-button,.text-info , .ns-icon-youtube ,.mb-d1-2 ,.px-d2 ,.ns-tabs__item ,.panel-schedules ,.ns-tabs, .button-tabs,.ns-layout__footer__footer,.hidden-cl").css("background-color", "")
        $(" .pb-d6 ,.panel-schedules ,.px-d2 ").css("color", "")
        $("#iconorestablecer").css("color", "#1e1e1e");
        $("#iconorestablecer").css("background-color", "#fff")
        $("#textorestablecer").css("color", "#1e1e1e");
        $("#textorestablecer").css("background-color", "#fff")
        $("#linkhome").css("color", "")
        $(".textomenu").css("color", "")
        $(".tablacss ").css("color", "")
        $(".tablacss ").css("background-color", "")
        $(".ns-icon-angle-left ").css("color", "")
        $(".ns-icon-angle-left ,.colorFondo  ").css("background-color", "")
      }

    }
  }
})
